import React from 'react';
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AddressComponent = (props: any) => {

    const { t, i18n } = useTranslation();
    const shippingDetails = i18n.exists("forms.shippingDetails") ? t('forms.shippingDetails') : "Детайли за доставка";
    const cityLbl = i18n.exists("forms.city") ? t('forms.city') : "Град";
    const addressLbl = i18n.exists("forms.address") ? t('forms.address') : "Адрес";
    const postalCodeLbl = i18n.exists("forms.postalCode") ? t('forms.postalCode') : "Пощенски код";
    const finishOrder = i18n.exists("forms.finishOrder") ? t('forms.finishOrder') : "Завърши поръчката";
    const toOfficeLbl = i18n.exists("forms.toOfficeLbl") ? t('forms.toOfficeLbl') : "До офис";
    const toAddress = i18n.exists("forms.toAddress") ? t('forms.toAddress') : "До адрес";
    const chooseOffice = i18n.exists("forms.chooseOffice") ? t('forms.chooseOffice') : "Изберете офис";
    const chooseDelivery = i18n.exists("forms.chooseDelivery") ? t('forms.chooseDelivery') : "Изберете доставка";
    const [validated, setValidated] = useState(false);
    const [isToOfficeDelivery, setToOffice] = useState(false);
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    let [cityValue, setCityValue] = useState(authUser.city || "");
    let [addressValue, setAddressValue] = useState(authUser.address || "");
    let [postalCodeValue, setPostalCodeValue] = useState(authUser.postalCode || "");
    const { city, address, postalCode } = authUser;
    const defaultFormData = {
        city: city,
        address: address,
        postalCode: postalCode
    }
    let [dataForm, setForm] = useState(defaultFormData);

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form: any = event.currentTarget;
        let formData: any  = {...dataForm};
        const data:any = new FormData(event.currentTarget)
        //console.log(data.entries())
        //let formObject = Object.fromEntries(data.entries())
        let d = data.entries();
        for (let [key, value] of d) {
            formData[key] = value;
            if(key === 'city') {
                setCityValue(value);
            }
            if(key === 'address') {
                setAddressValue(value);
            }
            if(key === 'postalCode') {
                setPostalCodeValue(value);
            }
            //console.log(key, value);
        }

        dataForm = formData;
        setForm(formData);
        
        if (form.checkValidity() === true) {
            //loginUser(loginForm);
            //console.log(formData)
            if(props.formData) {
                props.formData(formData);
            }
        }
        else {
        }
        //setValidated(true);
    };

    const loginUser = (user: any) => {
        console.log(user);
        httpService.loginUser(JSON.stringify(user)).then((res) => {
            if(res) {
                console.log(res);
                if(res.data) {
                    // TODO: get the token from the "data" object
                    window.location.href = "/";
                }
            }
        })
        .catch((err) => {
            console.log(err);
            let msg = err.response.data ? err.response.data: t('forms.commonErrMsg');
            if(msg === "Invalid credentials.") {
                msg = t('forms.invalidCredentials')
            }
            toast.error(msg);
        })
    }

    const deliveryTypeOnselect = (e: any) => {
        console.log(e.target.value)
        // 1 = to address
        // 2 = to office
        if(e.target.value === "1") {
            setToOffice(false);
        }
        else {
            setToOffice(true);
        }
    }

    const officeOnSelect = (value: any) => {
        console.log(value);
    }

    useEffect(() => {
        if(props.formData) {
            props.formData(dataForm);
        }
    }, [])

    return (
        <div>
            <h3>{shippingDetails}</h3>
            <div>
                <ToastContainer position="top-center"
 />
                <Form noValidate validated={validated} onSubmit={handleSubmit} onChange={handleSubmit}>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="city">
                            <Form.Label>{cityLbl}*</Form.Label>
                            <Form.Control 
                                type="text"
                                name="city"
                                value={cityValue}
                                required
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="12" controlId="validationCustom08">
                            <Form.Label>{addressLbl}*</Form.Label>
                            <Form.Control type="text" name="address" value={addressValue} required />
                        </Form.Group>
                        <Form.Group as={Col} md="12" className='postal-code' controlId="validationCustom09">
                            <Form.Label>{postalCodeLbl}*</Form.Label>
                            <Form.Control type="text" name="postalCode" value={postalCodeValue} required />
                        </Form.Group>
                        {/* <Form.Group as={Col} md="8" controlId="validationCustom10">
                            <Form.Label>{chooseDelivery}*</Form.Label>
                            <select className='form-control' onChange={(e) => deliveryTypeOnselect(e)} defaultValue={"1"}>
                                <option value="1">{toAddress}</option>
                                <option value="2">{toOfficeLbl}</option>
                            </select>
                        </Form.Group> */}
                        {isToOfficeDelivery ? (
                            <Form.Group as={Col} md="6" controlId="validationCustom11">
                                <Form.Label>{chooseOffice}*</Form.Label>
                                <select className='form-control' onChange={(e) => officeOnSelect(e)} defaultValue={"1"}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </select>
                            </Form.Group>
                        ) : null}
                        {/* <Form.Group as={Col} xs="12" controlId="validationCustom10">
                            <div className='align-center btn-out margin-0'>
                                <Button type="submit">{finishOrder}</Button>
                            </div>
                        </Form.Group> */}
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default AddressComponent;